import httpRequest from '../../utils/request'

const categoryCreate = async (category) => {
    // localhost:5000/api/category/add-category 
    const response = await httpRequest.post("/category/add-category", category)
    return response.data
}

const getCategories = async () => {
    // localhost:5000/api/category/get-categories 
    const response = await httpRequest.get("/category/get-categories")
    return response.data
}

const updateCategory = async (id, body) => {
    const response = await httpRequest.patch(`/category/update/${id}`, body)
    return response.data
}

const deleteCategory = async (id) => {
    const response = await httpRequest.delete(`/category/delete/${id}`)
    return response.data
}

const categoryService = {
    categoryCreate,
    getCategories,
    updateCategory,
    deleteCategory
}

export default categoryService